import React from 'react';

const SectionHeader = ({ text, tw }) => {
  return <h2 className={`text-2xl uppercase tracking-wide ${tw}`}>{text}</h2>;
};

export default SectionHeader;
